import { createFileRoute, notFound } from "@tanstack/react-router";
import { parseNavigationOrigin } from "../lib/navigationOrigin";
import { type AssetId, assetIdSchema } from "../lib/workIds";
import { AssetDetailScreen } from "../screens/AssetDetailScreen";

export const Route = createFileRoute("/_app/assets/$assetId")({
  params: {
    parse: (params): { assetId: AssetId } => {
      const parsed = assetIdSchema.safeParse(params.assetId);
      if (!parsed.success) throw notFound();
      return { assetId: parsed.data };
    },
  },
  component: AssetDetailRoute,
});

function AssetDetailRoute() {
  const { assetId } = Route.useParams();
  const search = Route.useSearch();
  const {
    assetCollapsedIds,
    assetKind,
    assetSearch,
    assetSelectedId,
    assetSort,
    assetSortDir,
  } = search;
  return (
    <AssetDetailScreen
      assetId={assetId}
      assetTreeSearch={{
        assetCollapsedIds,
        assetKind,
        assetSearch,
        assetSelectedId,
        assetSort,
        assetSortDir,
      }}
      origin={parseNavigationOrigin(search)}
    />
  );
}
